<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kategori ZIS</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="kategoriList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="category"
          label="name"
          v-model="formData.kat_id"
          placeholder="Pilih Kategori ZIS"
        />
        <span class="text-danger text-sm">{{ errors.first("category") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Sub-Kategori ZIS</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :disabled="formData.kat_id === null"
          :options="subKategoriList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="sub-category"
          label="name"
          v-model="formData.sub_id"
          placeholder="Pilih Sub-Kategori ZIS"
        />
        <span class="text-danger text-sm">{{ errors.first("sub-category") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Zakat Fitrah</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="zakat fitrah name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Zakat Fitrah"
        />
        <span class="text-danger text-sm">{{ errors.first("zakat fitrah name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nominal Zakat Fitrah (Rp)</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="zakat fitrah nominal"
          class="w-full sidebar-input"
          v-model="formData.nominal"
          placeholder="Isi Dengan Nominal Zakat Fitrah"
        />
        <span class="text-danger text-sm">{{
          errors.first("zakat fitrah nominal")
        }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Tanggal Mulai</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <flat-pickr
          class="w-full sidebar-input"
          :config="configFromdateTimePicker"
          v-model="formData.mulai"
          placeholder="Tentukan Tanggal Mulai"
          @on-change="onFromChange"
        />
        <span v-if="formData.mulai === ''" class="text-danger text-sm"
          >Start date cannot be empty</span
        >
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Tanggal Selesai</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-if="formData.mulai === ''"
          :disabled="true"
          class="w-full sidebar-input"
          placeholder="Tentukan Tanggal Selesai"
        />
        <flat-pickr
          v-else
          class="w-full sidebar-input"
          :config="configTodateTimePicker"
          v-model="formData.selesai"
          placeholder="Tentukan Tanggal Selesai"
          @on-change="onToChange"
        />
        <span v-if="formData.selesai === ''" class="text-danger text-sm"
          >End date cannot be empty</span
        >
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Deskripsi</strong></h6>
        </section>
        <vs-textarea
          class="w-full sidebar-input"
          v-model="formData.description"
          placeholder="Isi Dengan Deskripsi Zakat Fitrah"
        />
        <!-- <span class="text-danger text-sm">{{ errors.first("description") }}</span> -->
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    flatPickr,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      emptyImage,
      url,
      subKategoriList: [],
      configFromdateTimePicker: {
        minDate: null,
        maxDate: new Date("2022-05-03"),
        enableSeconds: true,
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
      },
      configTodateTimePicker: {
        minDate: null,
        maxDate: new Date("2022-05-03"),
        enableSeconds: true,
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
      },
      formData: {
        user_id: null,
        kat_id: null,
        sub_id: null,
        name: "",
        nominal: null,
        description: "",
        mulai: "",
        selesai: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Zakat Fitrah" : "Tambah Zakat Fitrah";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    kategoriList() {
      return this.$store.state.zis.kategoriList;
    },
    checkCategory() {
      return (
        this.$store.state.zis.kategoriList.find(
          (v) => v.name === "Zakat" || v.name === "Zakat Fitrah"
        ) !== undefined &&
        this.$store.state.zis.subKategoriList.find((v) => v.name === "Zakat Fitrah") !==
          undefined
      );
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.nominal !== null &&
        this.formData.mulai !== "" &&
        this.formData.selesai !== ""
      );
    },
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
    katSelect() {
      return this.formData.kat_id;
    },
  },
  watch: {
    katSelect() {
      if (this.formData.kat_id !== null) {
        this.subKategoriList = this.$store.getters["zis/getFilteredSubKategori"](
          this.formData.kat_id
        );
        if (this.formData.sub_id !== null) {
          if (
            this.subKategoriList.find((v) => v.id === this.formData.sub_id) === undefined
          ) {
            this.formData.sub_id = null;
          }
        }
      } else {
        this.formData.sub_id = null;
      }
    },
    activate() {
      if (this.passData !== null) {
        this.formData.user_id = this.passData.user.id;
        this.formData.kat_id = this.passData.sub_kategori
          ? this.passData.sub_kategori.kategori
            ? this.passData.sub_kategori.kategori.id
            : null
          : null;
        this.formData.sub_id = this.passData.sub_kategori
          ? this.passData.sub_kategori.id
          : null;
        this.formData.name = this.passData.name;
        this.formData.nominal = this.passData.nominal;
        this.formData.description = this.passData.description;
        this.formData.mulai = this.passData.mulai;
        this.formData.selesai = this.passData.selesai;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, "minDate", dateStr);
    },
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, "maxDate", dateStr);
    },
    resetForm() {
      this.formData.user_id = null;
      this.formData.kat_id = null;
      this.formData.sub_id = null;
      this.formData.name = "";
      this.formData.nominal = null;
      this.formData.description = "";
      this.formData.mulai = "";
      this.formData.selesai = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }

      // if (this.checkCategory) {
      //   this.formData.kat_id = this.$store.state.zis.kategoriList.find(
      //     (v) => v.name === "Zakat" || v.name === "Zakat Fitrah"
      //   ).id;
      //   this.formData.sub_id = this.$store.state.zis.subKategoriList.find(
      //     (v) => v.name === "Zakat Fitrah"
      //   ).id;
      // }
      this.formData.user_id = this.profile.id;
      this.$store
        .dispatch("zis/cudZafit", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Zakat Fitrah Sukses!"
                : "Tambah Zakat Fitrah Sukses!",
            text:
              this.passData !== null
                ? `Zakat Fitrah ${v.name} Berhasil diedit`
                : `Zakat Fitrah ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
